module.exports = __webpack_public_path__ + "static/media/pastor-slide3.88dc83f7.jpg";